<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称" />
            </a-form-item>
          </a-col>

          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {keywords:''}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">
            <a-icon type="upload" />上架
          </a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">
            <a-icon type="download" />下架
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="orderCount" slot-scope="text,record">
        <template>
          <div>{{record.pub_count}}/{{record.order_count}}</div>
        </template>
      </span>
      <span slot="skuDetail" slot-scope="text,record">
        <template>
          <span>{{record.goods_title}} ( {{record.sku_detail.sku_formart}} )x{{record.goods_count}}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">查看明细</a>
          <a-divider type="vertical" />
          <a @click="handleDown(record)">下载</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="删除后不可恢复,确定删除吗?"
            @confirm="deleteHandle(record)"
            okText="确定"
            cancelText="取消"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <a-modal
      title="操作"
      style="top: 20px;"
      :width="1000"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" hasFeedback>
            <a-input
            :disabled="formData.id>0"
              v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入礼品券名称' }]}
        ]"
              placeholder="请输入礼品券名称"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效时间" hasFeedback>
            <a-range-picker
              v-model="formData.get_date_range_moment"
              :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
          <!-- <a-form-item label="商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              showSearch
              :disabled="formData.id>0"
              optionFilterProp="title"
              v-model="formData.goods_id"
              placeholder="选择商品"
              @change="handleChange"
              allowClear
            >
              <a-select-option
                :key="option.id"
                v-for="option in goodsOptions"
                :title="option.title"
                :disabled="option.disabled"
                :value="option.id"
              >{{option.title}}</a-select-option>
            </a-select>
          </a-form-item> -->
          <!-- <a-form-item
            label="规格 "
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            v-if="formData.id>0"
          >
            <a-input :disabled="formData.id>0" v-model="sku_title" />
          </a-form-item>
          <a-form-item label="规格" :labelCol="labelCol" :wrapperCol="wrapperCol" v-else>
            <GoodsSkuPicker
              :formData="formData"
              :goodsId="goodsId"
              skuId="sku_id"
              skuTitle="sku_title"
              goodsPrice="goods_price"
              type="type"
              style="width:100%"
            ></GoodsSkuPicker>
          </a-form-item> -->

          <a-form-item label="内置产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div style="display:flex;justify-content:space-between" v-for="(item,k) in formData.extra_data" :key="k">
              <div style="width:35%"><a-select
                showSearch
                :disabled="formData.id>0"
                optionFilterProp="title"
                v-model="item.goods_id"
                placeholder="选择商品"
                @change="handleChange"
                allowClear
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in goodsOptions"
                  :title="option.title"
                  :disabled="option.disabled"
                  :value="option.id"
                >{{option.title}}</a-select-option>
              </a-select></div>
              <div style="width:35%">
                <a-input v-if="formData.id>0" :disabled="formData.id>0" v-model="item.sku_title" />
                
                <div v-else><GoodsSkuPicker
                
                :formData="item"
                :goodsId="item.goods_id"
                skuId="sku_id"
                skuTitle="sku_title"
                goodsPrice="goods_price"
                type="type"
                style="width:100%"
              ></GoodsSkuPicker></div>
                

              </div>
              <div style="width:20%">
                <a-input
              type="number"
              :disabled="formData.id>0"
              v-model="item.goods_count"
              placeholder="商品数量"
            /></div>
              <div v-if="formData.id==0"><a-icon
                class="dynamic-delete-button"
                type="minus-circle-o"
                @click="() => removeExtraField(k)"
              /></div>
            </div>
            <div v-if="formData.id==0">
              <a-button type="dashed" style="width: 100%" @click="addExtraField">
                <a-icon type="plus" />增加产品
              </a-button>
            </div>
          </a-form-item>
          <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" hasFeedback>
            <a-input
              type="number"
              :disabled="formData.id>0"
              v-decorator="[
          'goods_count',
          {rules: [{ required: true, message: '请输入商品数量' }]}
        ]"
              placeholder="请输入商品数量"
            />
          </a-form-item> -->

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用说明" hasFeedback>
            <a-textarea
              autosize
              v-decorator="[
          'note',
          {rules: []}
        ]"
              placeholder="请输入规则"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发行数量" hasFeedback>
            <a-input
              type="number"
              :disabled="formData.id>0"
              v-decorator="[
          'count',
          {rules: [{ required: true, message: '请输入发行礼品券的数量' }]}
        ]"
              placeholder="礼品券发放的总数不大于10000"
            />
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
      title="领取明细"
      :width="1070"
      style="top: 100px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="userVisible"
      @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="userColumns"
            :dataSource="giftCardList"
            :pagination="giftcardPagination"
            @change="handleUserTableChange"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-model="giftQuery.keywords"
                placeholder="搜索卡号"
                style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                type="primary"
                @click="userSearch(selectedKeys, confirm)"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                @click="userSearchReset(selectedKeys, confirm)"
                size="small"
                style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">{{record.name}}</span>
            <span slot="status" slot-scope="text,record">
              <a-badge status="processing" v-if="record.status==1 " text="未发行" />
              <a-badge status="processing" v-if="record.status==2 " text="已发行" />
              <a-badge status="success" v-else-if="record.status==3" text="已使用" />
              <a-badge status="processing" v-else-if="record.status==4" text="已销毁" />
            </span>
            <span slot="note" slot-scope="text,record">
              <template>
                <editable-cell :text="text" @change="changeNote(record.id,  $event)" />
              </template>
            </span>
            <span slot="cardAction" slot-scope="text,record">
              <template>
                <a @click="handleLogDetail(record)">日志</a>
                <a-divider type="vertical" />
                <span>
                  <a-popconfirm
                    title="是否确认发行"
                    @confirm="cardPub(record)"
                    okText="确定"
                    cancelText="取消"
                  >
                    <a v-if="record.status==1" href="javascript:;">发行</a>
                  </a-popconfirm>
                </span>

                <span>
                  <a-popconfirm
                    title="是否确认作废"
                    @confirm="cardCancel(record)"
                    okText="确定"
                    cancelText="取消"
                  >
                    <a v-if="record.status==2" href="javascript:;">作废</a>
                  </a-popconfirm>
                </span>

                <a v-if="record.status==3" @click="handleOrderDetail(record)">相关订单</a>
              </template>
            </span>
          </a-table>
        </a-form>
      </a-spin>
      <template slot="footer" slot-scope="text,record">
        <span>
          <a-popconfirm
            title="是否全部作废"
            @confirm="handleAllCancel(record)"
            okText="确定"
            cancelText="取消"
          >
            <a-button key="cancel" :loading="saveLoading">全部作废</a-button>
          </a-popconfirm>
        </span>
        &nbsp;&nbsp;
        <span>
          <a-popconfirm title="是否全部发行" @confirm="handleAllPub(record)" okText="确定" cancelText="取消">
            <a-button key="forward" :loading="saveLoading" type="primary">全部发行</a-button>
          </a-popconfirm>
        </span>
      </template>
    </a-modal>

    <a-modal title="日志" v-model="shareVisible" @ok="shareVisible=false">
      <a-timeline>
        <a-timeline-item v-for="log in logList" :key="log.id">
          {{log.create_time|timeFormat}}
          <b>{{log.user_name}}</b>
          {{log.title}}
          <span v-if="log.note" class="gray">备注:{{log.note}}</span>
        </a-timeline-item>
      </a-timeline>
    </a-modal>

    <a-modal
      title="相关订单"
      :width="1070"
      style="top: 100px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="giftOrderVisible"
      @ok="giftOrderVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="giftOrderColumns"
            :dataSource="giftOrderList"
            :pagination="giftOrderPagination"
            @change="handleGiftOrderChange"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
             
          <span slot="orderAction" slot-scope="text,record">
              <template> 
                <a  @click="handleGiftOrderDetail(record)">查看订单</a>
              </template>
            </span>
          </a-table>
        </a-form>
      </a-spin>
      <template slot="footer" slot-scope="text,record">
         
         
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PriceInput from '@/components/PriceInput/'
import moment from 'moment'
import UsersPicker from '@/components/UsersPicker/'
import GoodsSkuPicker from '@/components/GoodsPicker/GoodsSkuPicker/'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
import {
  getGoodsOptions,
  getCouponList,
  getCouponDetail,
  addCoupon,
  editCoupon,
  deleteCoupon,
  setCouponAllStatus,
  getCouponUserList,
  sendCoupon
} from '@/api/coupon'
import {
  addGift,
  getGiftList,
  getGiftDetail,
  AddGiftCard,
  deleteGift,
  getGiftCardList,
  cardPub,
  cardCancel,
  editGift,
  giftCardLogList,
  giftCardDownload,
  cardAllPub,
  editCard,
  cardAllCancel,
  editNote,
  getGiftOrderList
} from '@/api/gift'
import { skuDetail } from '@/api/goods'
import { getShopUserList } from '@/api/businessShop'
import { log } from 'util'
export default {
  name: 'GiftList',
  components: {
    AInput,
    ATextarea,
    STable,
    PriceInput,
    EditableCell,
    RSwitch,
    UsersPicker,
    GoodsSkuPicker
  },
  data() {
    return {
      goodsId: 0,
      sku_title: '',
      sku_id: 0,
      giftId: 0,
      visible: false,
      shareVisible: false,
      saveLoading: false,
      userVisible: false,
      giftOrderVisible:false,
      logList: [],
      gift_id: 0,
      share: {
        wxmini_pic_url: ''
      },
      formData: {
        id: 0,
        title: '',
        get_date_range: [],
        get_date_range_moment: [], //有效时间
        type: '', //商品类型
        goods_id: '', //商品
        sku_id: '', //商品规格
        sku_title: '',
        goods_count: 1, //商品数量
        note: '', //使用规则
        count: 0, //发行数量,
        order_count: 0,
        pub_count: 0, //已发行数量
        status: 1,
        extra_data: []
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      userFormData: {
        user_list: undefined,
        count: 1
      },

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: ''
      },
      cateOptions: [],
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '名称',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title1' }
        },
        {
          width: '100px',
          title: '数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' }
        },
        // {
        //   title: '商品(规格)',
        //   dataIndex: 'sku_id',
        //   scopedSlots: { customRender: 'skuDetail' }
        // },
        {
          title: '发行/使用',
          width: '150px',
          dataIndex: 'order_count',
          scopedSlots: { customRender: 'orderCount' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '300px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData', parameter)
        console.log(this.queryParam)
        this.queryParam = Object.assign(this.queryParam, parameter)
        console.log(this.queryParam)
        // this.queryParam={
        //   keywords:this.queryParam.keywords,
        //   p:parameter.pageNo,
        //   size:parameter.pageSize
        // }
        return getGiftList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],
      goodsOptions: [],
      skuList: [],
      //领取人员表头
      userColumns: [
        {
          title: 'ID',
          width: '70px',
          dataIndex: 'id'
        },
        {
          title: '卡号',
          width: '100px',
          dataIndex: 'code',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'code'
          }
        },
        {
          title: '密码',
          width: '80px',
          dataIndex: 'password'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: {
            customRender: 'status'
          },
          filters: [
            {
              text: '未发行',
              value: '1'
            },
            {
              text: '未使用',
              value: '2'
            },
            {
              text: '已使用',
              value: '3'
            },
            {
              text: '已销毁',
              value: '4'
            }
          ],
          filterMultiple: false
        },
        {
          title: '发行时间',
          width: '160px',
          dataIndex: 'pub_time',
          customRender: text => {
            if (!text) {
              return '-'
            }
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '使用时间',
          width: '160px',
          dataIndex: 'order_time',
          customRender: text => {
            if (!text) {
              return '-'
            }
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '备注(可编辑)',
          dataIndex: 'note',
          width: '180px',
          scopedSlots: { customRender: 'note' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'cardAction' }
        }
      ],
      giftOrderColumns: [
        {
          title: '订单ID',
          width: '100px',
          dataIndex: 'order_id'
        },
        {
          title: '商品名称',
          width: '500px',
          dataIndex: 'title', 
        },
        {
          title: '下单时间',
          width: '200px',
          dataIndex: 'order_time',
          customRender: text => {
            if (!text) {
              return '-'
            }
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },{
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'orderAction' }
        }],

      giftcardPagination: {
        pageSize: 10,
        pageNo: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      giftQuery: {
        gift_id: 0,
        status: 0,
        pageNo: 1,
        keywords: undefined
      },
      giftCardList: [],
      giftOrderPagination: {
        pageSize: 10,
        pageNo: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      giftOrderQuery: {
        card_id: 0,
        pageNo: 1,
        keywords: undefined
      },
      giftOrderList:[]
    }
  },
  computed: {},
  created() {},
  mounted() {
    let that = this
    that.getGoodsOptions()
  },
  methods: {
    addExtraField() {
      if (this.formData.extra_data.length && this.formData.extra_data[this.formData.extra_data.length - 1].name == '') {
        return false
      }
      this.formData.extra_data.push({ goods_id: '', sku_id:'',goods_count:1,sku_title:'' })
    },
    removeExtraField(k) {
      this.formData.extra_data.splice(k, 1)
    },
    //查看相关订单
    handleOrderDetail(record) {
      console.log(record)
      let self = this
      self.giftOrderQuery.card_id = record.id
      self.giftOrderPagination.pageNo = 1
      self.giftOrderVisible=true
       self.getViewGiftOrderList()
      // if (record.type == 'shop') {
      //   const { href } = this.$router.resolve({ name: 'ShopOrderDetail', query: { id: record.order_id } })
      //   window.open(href, '_blank')
      // } else {
      //   let { href } = this.$router.resolve({ name: 'OrderDetail', query: { id: record.order_id } })
      //   window.open(href, '_blank')
      // }
    },
    getViewGiftOrderList(){
      getGiftOrderList(Object.assign(this.giftOrderQuery, this.giftOrderPagination)).then(res => {
        const pagination = { ...this.giftOrderPagination }
        pagination.total = res.data.total
        this.giftOrderList = res.data.list
        this.giftOrderPagination = pagination 
      })
    },
    // 查看订单
    handleGiftOrderDetail(record){
      if (record.type == 'shop') {
        const { href } = this.$router.resolve({ name: 'ShopOrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      } else if(record.type == 'base') {
        let { href } = this.$router.resolve({ name: 'OrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      }else if(record.type == 'ticket') {
        let { href } = this.$router.resolve({ name: 'TicketOrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      }else if(record.type == 'hotel') {
        let { href } = this.$router.resolve({ name: 'HotelOrderDetail', query: { id: record.order_id } })
        window.open(href, '_blank')
      }
    },
    //编辑备注
    changeNote(key, value) {
      let self = this
      editNote({
        id: key,
        note: value
      })
        .then(res => {
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    //全部作废
    handleAllCancel() {
      this.saveLoading = true
      console.log(this.giftQuery.gift_id)
      cardAllCancel({ id: this.giftQuery.gift_id })
        .then(res => {
          this.saveLoading = false
          this.getCardList()
        })
        .catch(err => {
          console.log(err)
          this.$message.error(err.data.msg)
          this.saveLoading = false
        })
    },
    //全部发行
    handleAllPub() {
      this.saveLoading = true
      console.log(this.giftQuery.gift_id)
      cardAllPub({ id: this.giftQuery.gift_id })
        .then(res => {
          this.saveLoading = false
          this.getCardList()
        })
        .catch(err => {
          console.log(err)
          this.$message.error(err.data.msg)
          this.saveLoading = false
        })
    },
    //下载
    handleDown(record) {
      giftCardDownload({ id: record.id }).then(res => {
        console.log(res)
        window.open(res.data)
      })
    },
    //查看日志
    handleLogDetail(record) {
      let that = this
      this.shareVisible = true
      let data = {
        gift_id: record.gift_id,
        card_id: record.id
      }
      console.log(that.logList)
      giftCardLogList(data).then(res => {
        console.log(res.data)

        that.logList = res.data
      })
    },
    //选择商品加载商品Sku
    handleChange() {
      console.log(this.goodsOptions)
      this.goodsOptions.map(item => {
        if (item.id == this.formData.goods_id) {
          this.formData.type = item.type
        }
      })
      this.formData.sku_id = null
      this.goodsId = this.formData.goods_id
    },

    //单个发行
    cardPub(record) {
      let that = this
      that.saveLoading = true
      cardPub({ id: record.id })
        .then(res => {
          that.saveLoading = false
          that.getCardList()
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    cardCancel(record) {
      let that = this
      that.saveLoading = true
      cardCancel({ id: record.id })
        .then(res => {
          that.saveLoading = false
          that.getCardList()
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    moment,
    //    批量发送优惠券

    handleCancel() {
      this.visible = false
    },
    // 增
    handleAdd() {
      let that = this

      this.visible = true
      this.form.resetFields()
      this.formData = {
        id: 0,
        title: '',
        get_date_range: [],
        get_date_range_moment: [], //有效时间
        goods_id: '', //商品
        sku_id: '', //商品规格
        sku_title: '',
        goods_count: 1, //商品数量
        note: '', //使用规则
        count: 10, //发行总数
        order_count: 0,
        pub_count: 1, //已发行数量
        status: 1,
        extra_data: []
      }
      setTimeout(() => {
        that.form.setFieldsValue({ ...this.formData })
      })
    },
    // 改
    handleEdit(record) {
      let self = this
      self.sku_title = ''
      // record.sku_detail.sku.map((item, i) => {
      //   self.sku_title += item.field + ':' + item.attr + ','
      // })

      getGiftDetail({ id: record.id }).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data })
        }, 1)
        //          self.formData = {...res.data};
        self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
        console.log(res.data.time_start)
        self.formData.id = res.data.id
        self.formData.get_date_range_moment = [moment(res.data.time_start * 1000), moment(res.data.time_end * 1000)]

        skuDetail({ goods_id: this.formData.goods_id }).then(res => {
          console.log(res.data.sku_fields_list[0])
          self.skuList = res.data.sku_fields_list[0].attrs
        })
        this.visible = true
      })
    },

    // 增改 处理
    handleOk(e) {
      let that = this
      e.preventDefault()
      if (that.formData.get_date_range_moment.length != 2) {
        that.$message.error('请选择领取时限')
        return
      }
      if (that.formData.extra_data.length==0) {
        that.$message.error('请选择商品')
        return
      }
      that.formData.extra_data.map((item,i)=>{
        if(!item.sku_id){
        that.$message.error('请选择商品规格')
      return
        }
      })
       
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', that.formData)
          that.saveLoading = true

          let formData = {
            id: that.formData.id,
            title: values.title,
            note: values.note,   
            pub_count: values.pub_count,
            order_count: that.formData.order_count,
            count: that.formData.count,
            status: that.formData.status,
            extra_data:that.formData.extra_data,
            get_date_range: [
              that.formData.get_date_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              that.formData.get_date_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          }
          // if(values.count>10000){
          //   that.$message.error('礼品券发放总数不能大于10000')
          // }
          console.log
          if (that.formData.id) {
            let formDatas = {
              id: that.formData.id,
              note: values.note,  
              extra_data:that.formData.extra_data,
              get_date_range: [
                that.formData.get_date_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
                that.formData.get_date_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
              ]
            }
            editGift(formDatas)
              .then(res => {
                that.$message.success('修改成功')
                that.$refs.table.refresh(true)
                that.visible = false
                that.saveLoading = false
              })
              .catch(err => {
                that.$message.error(err.data.msg)
                that.saveLoading = false
              })
          } else {
            addGift(formData)
              .then(res => {
                that.$message.success('新增成功')
                that.$refs.table.refresh(true)
                that.visible = false
                that.saveLoading = false
              })
              .catch(err => {
                that.$message.error(err.data.msg)
                that.saveLoading = false
              })
          }
        }
      })
    },
    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(true)
    },
    setAllStatus(status) {
      let self = this
      setCouponAllStatus({
        ids: self.selectedRowKeys,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(true)
      })
    },
    // 删
    deleteHandle(record) {
      let self = this
      deleteGift({ id: record.id })
        .then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    getGoodsOptions() {
      let self = this
      getGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },

    handleUserManage(record) {
      let self = this
      self.giftQuery.gift_id = record.id
      self.giftQuery.keywords = undefined
      self.giftQuery.status = 0
      self.giftcardPagination.pageNo = 1
      self.getCardList()
      this.userVisible = true
    },

    getCardList() {
      getGiftCardList(Object.assign(this.giftQuery, this.giftcardPagination)).then(res => {
        const pagination = { ...this.giftcardPagination }
        pagination.total = res.data.total
        this.giftCardList = res.data.list
        this.giftcardPagination = pagination
        console.log('获取卡号')
        // this.giftCardList = res.data.list

        // this.giftcardPagination.total = res.data.total
      })
    },

    userSearch(selectedKeys, confirm) {
      let self = this
      confirm()
      self.getCardList()
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this
      confirm()
      self.giftQuery.keywords = undefined
      self.getCardList()
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log('filters', filters)
      let that = this

      if (filters.status) {
        that.giftQuery.status = filters.status[0]
      } else {
        that.giftQuery.status = 0
      }
      const pager = { ...this.giftcardPagination }
      console.log('pagination', pagination)
      pager.current = pagination.current
      pager.pageNo = pagination.current
      that.giftcardPagination = pager
      that.getCardList()
    },
    handleGiftOrderChange(pagination, filters, sorter) {
      console.log('filters', filters)
      let that = this

      if (filters.status) {
        that.giftQuery.status = filters.status[0]
      } else {
        that.giftQuery.status = 0
      }
      const pager = { ...this.giftcardPagination }
      console.log('pagination', pagination)
      pager.current = pagination.current
      pager.pageNo = pagination.current
      that.giftcardPagination = pager
      that.getCardList()
    }
  },

  watch: {
    /*
              'selectedRows': function (selectedRows) {
                this.needTotalList = this.needTotalList.map(item => {
                  return {
                    ...item,
                    total: selectedRows.reduce( (sum, val) => {
                      return sum + val[item.dataIndex]
                    }, 0)
                  }
                })
              }
              */
  }
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>